import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

@Pipe({
    name: 'commaSeparator',
    standalone: true
})
export class CommaSeparatorPipe implements PipeTransform {

  transform(value: number | string): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

}
